import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-word-change-dialog',
  templateUrl: './confirm-word-change-dialog.component.html',
  styleUrls: ['./confirm-word-change-dialog.component.scss'],
})
export class ConfirmWordChangeDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ConfirmWordChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
